var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('Loading',{attrs:{"active":_vm.isLoading,"opaque":""}}):(!_vm.currentOffice || _vm.error)?_c('ErrorNote',{attrs:{"entityName":"office","error":_vm.error}}):(!_vm.currentOfficeIsApproved)?_c('OfficeStatusPage',{attrs:{"office":_vm.currentOffice}}):_c('OfficeDashboard')
}
var staticRenderFns = []

export { render, staticRenderFns }